define('plugin/deposit-paid-events/view/DepositPaidEventsPayFullAmountView',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Deposit paid events pay full amount view
     *
     * @class DepositPaidEventsPayFullAmountView
     */
    return Marionette.ItemView.extend({

        template: '#deposit_paid_events_pay_full_amount_view',

        ui: {
            btn: '#sb_deposit_paid_events_pay_full_amount_btn',
        },

        events: {
            'click @ui.btn': 'payFullAmount'
        },

        payFullAmount: function () {
            this.triggerMethod('pay:full:amount', this.model);
        },

    });

});
